import { useEffect } from "react";
import { useTweaksStore } from "@/stores/tweaksStore";

// Applies the current tweaks to <html>: dark/light theme + density var.
// Mirrors the prototype's effect — clears any stale inline accent vars and
// then sets data-theme + --dens on documentElement. Mount once at the app
// root (e.g. inside ProtectedShell or App).
export function useTheme(): void {
  const dark = useTweaksStore((s) => s.dark);
  const density = useTweaksStore((s) => s.density);

  useEffect(() => {
    const root = document.documentElement;

    // Remove any stale inline accent overrides from earlier sessions.
    ["--accent", "--accent-ink", "--accent-soft", "--accent-line"].forEach(
      (k) => root.style.removeProperty(k)
    );

    root.dataset.theme = dark ? "dark" : "light";
    root.style.setProperty("--dens", String(density));
  }, [dark, density]);
}
